import React from "react";
import { NavLink } from "react-router-dom";
import icons from "../../assets/icons/icon-collection.svg";
import { array, bool } from "prop-types";
import "./index.scss";

const SubMenu = ({ menuOptions, includeSVG, recruiter }) => {
  const containerClass = recruiter ? "recruiter-menu" : "sub-menu";
  return (
    <div className={containerClass}>
      {menuOptions.map((option) => {
        const isAction = typeof option[1] === "function";
        const content = (
          <>
            <span className="sub-menu-option__label d-flex align-items-center">
              {includeSVG && (
                <svg width="22" height="20" className="d-none d-md-block mr-3">
                  <use href={`${icons}#${option[0]}`}></use>
                </svg>
              )}
              <span>{option[0]}</span>
            </span>
            <span className="sub-menu-option__arrow d-flex">
              <svg
                width="12"
                height="20"
                className={
                  option[2]
                    ? "down sub-menu-option__arrow-icon"
                    : "sub-menu-option__arrow-icon"
                }
              >
                <use href={`${icons}#arrow`}></use>
              </svg>
            </span>
          </>
        );

        if (isAction) {
          const isActive = option[3] ? "active" : "";
          return (
            <div
              className={`sub-menu-link d-flex align-items-center justify-content-between medium-text cursor-pointer ${isActive}`}
              style={{ cursor: "pointer" }}
              key={option[0]}
              onClick={option[1]}
            >
              {content}
            </div>
          );
        }

        return (
          <NavLink
            className="sub-menu-link d-flex align-items-center justify-content-between medium-text"
            key={option[0]}
            to={option[1]}
            isActive={(match, location) => {
              if (option[3] === false) return false;
              if (option[3] === true) return true;
              return !!match;
            }}
          >
            {content}
          </NavLink>
        );
      })}
    </div>
  );
};

SubMenu.propTypes = {
  menuOptions: array.isRequired,
  includeSVG: bool,
  recruiter: bool,
};

SubMenu.defaultProps = {
  includeSVG: false,
  recruiter: false,
};

export default SubMenu;
